import CardElementStickerControl from './CardElementStickerControl';

export default CardElementStickerControl;
